import script from "./CropImage.vue?vue&type=script&setup=true&lang=js"
export * from "./CropImage.vue?vue&type=script&setup=true&lang=js"

import "./CropImage.vue?vue&type=style&index=0&id=082b81b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082b81b8"]])

export default __exports__